import { Button as MuiButton, styled } from '@mui/material';

export const Button = styled(MuiButton)(({ theme }) => ({
  ...theme.typography.overline,
  // A tile, not an outlined button: no fill or border until hovered.
  backgroundColor: 'transparent',
  borderColor: 'transparent',
  color: theme.palette.text.secondary,
  flexDirection: 'column',
  // Top-align so a one-line label keeps its icon and text level with wrapped neighbours,
  // which MUI's default centring pushes down.
  justifyContent: 'flex-start',
  // A crowded row shrinks tiles down to their longest word, then scrolls, so labels wrap only
  // between words. A word wider than maxWidth widens the tile instead of being split or
  // clipped (min-width wins over max-width), which also covers WCAG 1.4.12 text spacing.
  minWidth: 'min-content',
  maxWidth: '120px',
  padding: theme.spacing(1),
  textAlign: 'center',
  whiteSpace: 'normal',
  overflow: 'hidden',
  lineHeight: 1.2,
  '& span': {
    margin: 0,
    marginBottom: theme.spacing(1),
  },
  '&:hover': {
    borderColor: theme.palette.borders.light,
    backgroundColor: theme.palette.background.default,
  },
  '&.Mui-disabled': {
    border: 0,
  },
}));
